import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { boardStateAtom, selectedIdsAtom } from '@/store/boardAtoms';
/**
 * Хук для получения выбранных элементов и их общей маски
 * @returns объект с выбранными элементами и общей маской
 */
export const useSelectedElements = () => {
    const selectedIds = useAtomValue(selectedIdsAtom);
    const boardState = useAtomValue(boardStateAtom);
    return useMemo(() => {
        var _a, _b, _c, _d, _e;
        const layers = (_a = boardState === null || boardState === void 0 ? void 0 : boardState.layers) !== null && _a !== void 0 ? _a : [];
        const elements = [];
        let mask = null;
        const selectedIdsSet = selectedIds.length > 0 ? new Set(selectedIds) : new Set();
        for (const layer of layers) {
            for (const el of (_b = layer === null || layer === void 0 ? void 0 : layer.elements) !== null && _b !== void 0 ? _b : []) {
                if (!selectedIdsSet.has(el.id))
                    continue;
                elements.push(el);
                // Вычисляем общую маску для всех выбранных элементов
                const elementMask = ((_e = (_d = (_c = el.props) === null || _c === void 0 ? void 0 : _c.clip) === null || _d === void 0 ? void 0 : _d.type) !== null && _e !== void 0 ? _e : 'none');
                if (mask === null) {
                    mask = elementMask;
                }
                else if (mask !== elementMask) {
                    mask = 'none';
                }
            }
        }
        return {
            selectedElements: elements,
            selectionMask: mask !== null && mask !== void 0 ? mask : 'none',
        };
    }, [boardState.layers, selectedIds]);
};
